define('util/airspeed',["require", "exports", "./physics"], function (require, exports, ph) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.adjustSpeed = exports.trueToIndicated = void 0;
    /**
     * Convert GPS speed to indicated airspeed (how the wing feels, or what its speed would be at sea level)
     * @param trueSpeed speed as measured by GPS
     * @param altitude height that speed was measured at
     * @return indicated airspeed (IAS)
     */
    function trueToIndicated(trueSpeed, altitude) {
        var pressure = ph.altitudeToPressure(altitude);
        var temp = ph.temp(altitude);
        var rho = pressure * ph.mmAir / (ph.gasConst * temp);
        var ratio = Math.sqrt(rho / ph.rho0);
        return ratio * trueSpeed;
    }
    exports.trueToIndicated = trueToIndicated;
    /**
     * Adjust speed to a different altitude
     * @param trueSpeed speed as measured by GPS at altitude fromAlt
     * @param fromAlt height that speed was measured at
     * @param toAlt height to adjust to
     * @return speed if aircraft was at toAlt in same flight configuration
     */
    function adjustSpeed(trueSpeed, fromAlt, toAlt) {
        var pressure1 = ph.altitudeToPressure(fromAlt);
        var temp1 = ph.temp(fromAlt);
        var rho1 = pressure1 * ph.mmAir / (ph.gasConst * temp1);
        var pressure2 = ph.altitudeToPressure(toAlt);
        var temp2 = ph.temp(toAlt);
        var rho2 = pressure2 * ph.mmAir / (ph.gasConst * temp2);
        var ratio = Math.sqrt(rho1 / rho2);
        return ratio * trueSpeed;
    }
    exports.adjustSpeed = adjustSpeed;
});
//# sourceMappingURL=/assets/javascripts/util/airspeed.js.map;
